class DataService {
    constructor() {
        if (location.hostname === 'localhost') {
            this.host = "https://qa.coast.noaa.gov";

            // const headers = new Headers();
            // headers.append('origin', '0.0.0.0');
            // this.options = { headers };
        }
        else {
            this.host = `https://${location.hostname}`;
            this.options = {};
        }
    }

    async getYears(datatypeId) {
        // console.log('%cTRACE: getYears', 'color: green; font-weight: 900; background: white');
        const response = await fetch(`${this.host}/enow/api/v1/${datatypeId}/years`);
        const json = await response.json();
        const years = json.years.map(y => y.toString());

        years.sort((a, b) => {
            const aYear = parseInt(a.substring(0, 4), 10);
            const bYear = parseInt(b.substring(0, 4), 10);
            return aYear - bYear;
        });

        return years;
    }

    async getReportData(datatype, geotype, years, fips) {
        // console.log('%cTRACE: getReportData', 'color: green; font-weight: 900; background: white');
        if (datatype && geotype && years && fips) {
            try {
                const url = this.buildUrl(datatype, geotype, fips.join(','), years.join(','));
                const response = await fetch(url);
                if (response.status !== 200) {
                    throw new Error(`${response.status}: ${response.statusText}`);
                }

                const json = await response.json();
                return json;
            }
            catch (err) {
                console.error(err);
                return null;
            }
        }
        else if (datatype === "openEnow") {
            try {
                const url = this.buildUrl(datatype, fips.join(','), years.join(','));
                const response = await fetch(url);
                if (response.status !== 200) {
                    throw new Error(`${response.status}: ${response.statusText}`);
                }

                const json = await response.json();
                return json;
            }
            catch (err) {
                console.error(err);
                return null;
            }
        }
    }

    async getCsv(data, datatype, geotype) {
        const csv = await this.arrayToCsv(data);
        this.downloadBlob(csv, `${datatype}_${geotype}.csv`, 'text/csv;charset=utf-8;');
    }

    async arrayToCsv(data) {
        const csvRows = [];
        const headers = Object.keys(data[0]);
        csvRows.push(headers.join(','));
        for (const row of data) {
            const values = headers.map(e => {
                return row[e];
            });
            if (values.includes('Total, all industries')) {
                values.splice(values.indexOf('Total, all industries'), 1, 'All Industries Total');
            }
            if (values.includes('Trade, Transportation, and Utilities')) {
                values.splice(values.indexOf('Trade, Transportation, and Utilities'), 1, 'Trade Transportation and Utilities');
            }
            csvRows.push(values.join(','));
        }

        return csvRows.join('\n');
    }

    downloadBlob(content, filename, contentType) {
        // Create a blob
        const blob = new Blob([content], { type: contentType });
        const url = URL.createObjectURL(blob);

        // Create a link to download it
        const pom = document.createElement('a');
        pom.href = url;
        pom.setAttribute('download', filename);
        pom.click();
    }

    buildUrl(datatype, geotype, fips, years) {
        // console.log('%cTRACE: buildUrl', 'color: green; font-weight: 900; background: white');
        if (datatype === 'demographics') {
            return `${this.host}/enow/api/v1/${datatype}?` +
            `geotype=${geotype}&geoid=${fips}&decade=${years}`;
        }
        return `${this.host}/enow/api/v1/${datatype}?` +
            `geotype=${geotype}&geoid=${fips}&year=${years}`;
    }
}

export default new DataService();
